<template>
	<intersect @enter="animate = true">
		<div
			class="tends-list fadeUp"
			:class="[
				addClass(itemData.columnTitles.length),
				animate ? 'animate' : '',
				pageUrl.endsWith('term-deposit') ? 'terms-list' :
				pageUrl.endsWith('without-collateral') ? 'collateral-list' :
				pageUrl.endsWith('money-transfers') ? 'money-transfers-list' : '',
				pageUrl.endsWith('bb_set') ? 'bb-set-list' : '',
				pageUrl.endsWith('migrated_rates') ? 'migrated-rates-list' : '',
			]"
		>
			<h2 class="title noto-semibold" v-if="_.get(itemData, 'title')">
				{{ _.get(itemData, 'title') }}
			</h2>

			<div
				class="text"
				v-if="_.get(itemData, 'top_teaser')"
				v-html="_.get(itemData, 'top_teaser')"
			></div>

			<swiper ref="mySwiper" :options="swiperOptions" class="tends-list-slider">
				<swiper-slide class="swiper-slide">
					<div class="top" v-if="_.get(itemData, 'columnTitles.0')">
						<div
							class="noto-semibold ttl"
							:class="[
								{ short: itemData.columnTitles.length > 2 },
								{ 'fixed-table-item': _.get(itemData, 'colTitlesFix') === '1' },
							]"
						>
							{{ _.get(itemData, 'definitions') }}
						</div>
						<div
							class="noto-semibold ttl"
							:class="{ short: itemData.columnTitles.length > 2 }"
							v-for="(columnTitles, index) in itemData.columnTitles"
							:key="index"
						>
							{{ columnTitles }}
						</div>
					</div>

					<div class="row" v-for="(item, index) in itemData.data" :key="index">
						<div
							class="item"
							:class="[
								{ short: item.length >= 2 },
								{
									'fixed-table-item': _.get(itemData, 'colTitlesFix') === '1',
								},
							]"
						>
							<div class="" v-html="itemData.rowTitles[index]"></div>
						</div>

						<div
							class="item"
							:class="{ short: item.length >= 2 }"
							v-for="(value, index) in item"
							v-html="value"
							:key="index"
						></div>

						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="2434.627"
							height="1.5"
							viewBox="0 0 2434.627 1.5"
						>
							<line
								id="Line_114"
								data-name="Line 114"
								x2="2434.127"
								y2="1"
								transform="translate(0.25 0.25)"
								fill="none"
								stroke="#bcbec0"
								stroke-linecap="round"
								stroke-width="0.5"
								stroke-dasharray="10"
							/>
						</svg>
					</div>
				</swiper-slide>
				<div class="swiper-scrollbar" slot="scrollbar">
					<div
						class="swiper-scrollbar-drag"
						style="width: 70px;"
						slot="scrollbar"
					></div>
				</div>
			</swiper>

			<template v-if="downloadListData">
				<div
					class="text"
					v-if="descArr[0]"
					v-html="descArr[0]"
				></div>

				<DownloadList
					v-if="downloadListData"
					:itemData="downloadListData"
				/>

				<div
					class="text"
					v-if="descArr.slice(1).length"
					v-html="descArr.slice(1).join('')"
				></div>
			</template>
			<template v-else>
				<div
					class="text"
					v-if="_.get(this.itemData, 'teaser')"
					v-html="_.get(this.itemData, 'teaser')"
				></div>
			</template>
		</div>
	</intersect>
</template>

<script>
	import mainMixin from "@/mixins/main";
	import Intersect from 'vue-intersect';
	import DownloadList from "@/components/DownloadList";

	export default {
		name: 'carrousel',
		mixins: [mainMixin],
		props: {
			itemData: {
				type: Object,
				require: true,
			},
			downloadListData: {
				type: Object,
			},
		},
		components: { Intersect, DownloadList },
		data() {
			return {
				animate: false,
				swiperOptions: {
					speed: 800,
					slidesPerView: 'auto',
					freeMode: true,
					watchOverflow: true,
					scrollbar: {
						el: '.swiper-scrollbar',
						hide: false,
						draggable: true,
						dragSize: 70,
						snapOnRelease: false,
					},
					on: {
						setTranslate(swiper, translate) {
							document.querySelectorAll('.fixed-table-item').forEach((item) => {
								item.style.left = Math.abs(translate) + 'px';
							});
						},
					},
				},
			};
		},
		computed: {
			swiper() {
				return this.$refs.mySwiper.$swiper;
			},
			pageUrl() {
				const selectedMenu = this.getMenuFromPath();
				
				if (selectedMenu && selectedMenu.full_url) {
					return selectedMenu.full_url;
				}

				return ""
			},
			descArr() {
				return _.get(this.itemData, 'teaser').split(/(?<=<.*?>)\s/);
			},
		},
		methods: {
			addClass(length) {
				if (length === 1) {
					return 'one';
				} else if (length === 2) {
					return 'two';
				} else if (length === 3) {
					return 'three more'
				}
				{
					return 'more';
				}
			},
		},
	};
</script>

<style>
	.fixed-table-item {
		background: white;
		max-width: 200px !important;
		position: absolute;
		left: 0;
		padding-left: 20px !important;
	}
</style>
